module.exports = "<div class=\"in-progress\">\n  <section class=\"message\">\n    <h1 class=\"message__title\">In Progress</h1>\n    <p class=\"message__text\">\n      Hi there! This place is still a bit empty but you can contact me directly\n      to my email:\n      <a class=\"message__link\" href=\"mailto:hello@fernicolosi.com\"\n        >hello@fernicolosi.com</a\n      >\n    </p>\n  </section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/inprogress/inprogress.view.component.html
// module id = ./src/app/views/inprogress/inprogress.view.component.html
// module chunks = main